import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  // CostTrend,
  OverviewCard,
  valueWithText,
  CardComponent,
  Breadcrumbs,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {
  // CostTrendChartType,
  // formatCostTrend,
  formatPEPM,
  formatPMPM,
  formatTotalCost,
  formatTotalEnrolled,
  getPepmForCohorts,
  getPepmValueForCohorts,
  getPmpmForCohorts,
  getPmpmValueForCohorts,
  PEPM,
  PMPM,
  TotalCost,
  TotalEnrolled,
} from '../../core-utils/helper-utils/summaryReportHelper';
import componentConstants from '../../core-utils/messages/componentConstants';
import ClaimsImpactChart from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/ClaimsImpact';
import ClaimMetricsPageTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/ClaimMetricsPageTable';
import properties from '../../core-utils/properties';
import Loader from '../../_components/molecules/Loader';
import {
  formatClaimMetricsTableData,
  formatClaimsImpactData,
  getHighestPaidOfClaimsImpactData,
  IClaimsImpactData,
  IHighestPaidData,
} from '../../core-utils/helper-utils/claimMetricsPageHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import messages from '../../core-utils/messages';
import { useStores } from '../../stores';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { useNavigate } from 'react-router-dom';
import { ENROLLMENT_METRICS, PLAN_PERFORMANCE } from '../../core-utils/routes';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import { observer } from 'mobx-react';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';

const ClaimMetricsPage = observer(() => {
  // styles
  const useStyles = makeStyles()({
    root: {
      width: '1176px',
      margin: '40px 52px 28px 52px',
    },
    headerContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: 'fit-content',
      marginBottom: '18px',
    },
    containedButton: {},
    outlinedButton: {},
    flex: {
      display: 'flex',
    },
  });

  const { classes } = useStyles();

  // constants
  const pageConstants = componentConstants.PAGES.CLAIM_METRICS_PAGE;
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  // states
  const [loading, setLoading] = useState<boolean>(false);
  const [totalEligible, setTotalEligible] = useState<number>(0);
  const [totalEnrolled, setTotalEnrolled] = useState<TotalEnrolled>({
    totalCount: '',
    dependents: '',
    employees: '',
  });
  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });
  const [pmpm, setPMPM] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });
  const [pepm, setPEPM] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });
  const [planPaidTableData, setPlanPaidTableData] = useState<string[][]>([]);
  const [memberPaidTableData, setMemberPaidTableData] = useState<string[][]>(
    [],
  );
  const [claimsImpactData, setClaimsImpactData] = useState<IClaimsImpactData>({
    medicalData: [],
    rxData: [],
  });
  const [
    claimsImpactHigestPaidData,
    setClaimsImpactHighestPaidData,
  ] = useState<IHighestPaidData>({
    medical: {
      name: '',
      value: '',
    },
    rx: {
      name: '',
      value: '',
    },
  });
  // const [
  //   costTrendChartData,
  //   setCostTrendChartData,
  // ] = useState<CostTrendChartType>({
  //   medicalClaimsData: [],
  //   medicalTotalPaid: [],
  //   rxTotalPaid: [],
  //   rxClaims: [],
  //   xAxisValues: [],
  // });
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const recommendedTabStore = useStores().recommendedTabStore;
  const screenName = allScreenLabel;
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };
  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        pageConstants.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  //api calls
  const getTotalEligible = async () => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.summaryBaseUrl,
        {
          ...payload,
          claim_id_list: [],
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setTotalEligible(res?.data?.data?.totalEligibleCount);
          setTotalEnrolled(formatTotalEnrolled(res?.data?.data));
          setTotalCost(formatTotalCost(res?.data?.data));
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const getPMPMAndPepm = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.pmpmAndPepm,
        {
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setPMPM(formatPMPM(res?.data?.data?.pmpm));
          setPEPM(formatPEPM(res?.data?.data?.pepm));
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const getTopPlanPaidTableData = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.claimMetricsUrl +
          properties.claimsTopPlanPaid,
        {
          ...payload,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setPlanPaidTableData(formatClaimMetricsTableData(res?.data?.data));
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const getTopMemberPaidTableData = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.claimMetricsUrl +
          properties.claimsTopMemberPaid,
        {
          ...payload,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setMemberPaidTableData(formatClaimMetricsTableData(res?.data?.data));
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const getClaimsImpactData = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.claimMetricsUrl +
          properties.claimsImpact,
        {
          ...payload,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setClaimsImpactData(formatClaimsImpactData(res?.data?.data));
          setClaimsImpactHighestPaidData(
            getHighestPaidOfClaimsImpactData(res?.data?.data),
          );
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  // const getCostTrendData = async () => {
  //   await axios
  //     .post(
  //       properties.aiqBaseUrl +
  //         properties.summaryBaseUrl +
  //         properties.costTrend,
  //       {
  //         ...payload,
  //         claim_id_list: [],
  //         member_unique_id_list: [],
  //       },
  //       { signal: abortController.signal },
  //     )
  //     .then((res) => {
  //       if (res?.status === 200) {
  //         setCostTrendChartData(formatCostTrend(res?.data?.data?.costTrend));
  //       }
  //     })
  //     .catch((error) => {
  //       handleOpenSnackBar(
  //         error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
  //         'error',
  //         8000,
  //       );
  //     });
  // };

  const getPageData = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        getTotalEligible(),
        getTopMemberPaidTableData(),
        getTopPlanPaidTableData(),
        getPMPMAndPepm(),
        getClaimsImpactData(),
        // getCostTrendData(),
      ]).then(() => {
        setLoading(false);
      }));

    setLoading(false);
  };
  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      const cleanSummaryData = {
        totalEligible,
        totalEnrolled,
        totalCost,
        pmpm,
        pepm,
      };

      const cleanTopPlanPaidData = {
        planPaidTableData,
      };

      const cleanTopMemberPaidData = {
        memberPaidTableData,
      };

      const cleanClaimsImpactData = {
        claimsImpactData,
        claimsImpactHigestPaidData,
      };

      const apiResponses = {
        title_1: cleanSummaryData,
        title_2: cleanTopPlanPaidData,
        title_3: cleanTopMemberPaidData,
        title_4: cleanClaimsImpactData,
      };

      let resultArray = [];

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.CLAIMS_METRICS,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
        console.error('AI Summary API failed:', apiError);
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error) {
      console.error('Unexpected Error:', error);
      handleOpenSnackBar(
        'Something went wrong. Please try again.',
        'error',
        6000,
      );
      setAiSummaryData([]);
    } finally {
      setAiLoading(false);
    }
  };

  // Edit duration related states and functions

  // const loginPageStore = useStores().loginPageStore;
  const pathStore = useStores().pathStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    employerGroupStore,
    loginPageStore,
    cohortDetailsStore,
  } = useStores();
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMembersCount(
        employerGroupStore.employerGroupResponseData.eg_nid,
        aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        employerGroupStore.employerGroupResponseData.max_claim_date,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  // useEffects
  useEffect(() => {
    if (isInitializing) {
      return;
    }
    getPageData();
    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);
  const [loader] = useState<any>(<Loader />);
  const navigate = useNavigate();
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  //click Here Navigation Functions -
  const pushToEnrollemntMetrics = () => {
    navigate(ENROLLMENT_METRICS);
  };
  const pushToPlanPerformance = () => {
    navigate(PLAN_PERFORMANCE);
  };
  const getPath = () => {
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };

  return isPlanDatesLoading || loading || isInitializing ? (
    loader
  ) : (
    <>
      <Grid container className={classes.root}>
        {getPath().length !== 0 && (
          <Box style={{ marginBottom: '20px' }}>
            <Breadcrumbs itemList={getPath()} />
          </Box>
        )}
        <Grid container className={classes.headerContainer}>
          <PageTitleAndSubTitle
            title={pageConstants.TITLE}
            chip={
              <Grid className={classes.flex}>
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="2px 8px 0px 0px"
                >
                  for
                </Typography>
                <DateFilter />
              </Grid>
            }
            subTitle={pageConstants.SUBTITLE}
            // showQueryDataButton={checkUserAccess(
            //   UserAccessConstants.COHORT_DETAILS,
            //   loginPageStore.userResponse.role.name,
            //   loginPageStore.userFeatures,
            // )}
            showDownloadButton
            // downloadButtonAction={() => setOpenReportsModal(true)}
            downloadButtonAction={() => {
              downloadPdf(
                'claimsReport',
                {
                  employer:
                    employerGroupStore?.employerGroupResponseData
                      ?.employer_group_name,
                  member_unique_id_list:
                    cohortDetailsStore.memberUniqueIdList || [],
                  claim_id_list: [],
                  maxClaimDate:
                    employerGroupStore?.employerGroupResponseData
                      ?.max_claim_date,
                  ...payload,
                },
                handleOpenSnackBar,
                'open',
              );
              handleOpenSnackBar(
                snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                'info',
                6000,
              );
            }}
            showAskAi={true}
            askAiAction={handleAskAi}
            showQueryDataButton={checkUserAccess(
              UserAccessConstants.COHORT_DETAILS,
              loginPageStore.userResponse.role.name,
              loginPageStore.userFeatures,
            )}
            queryButtonText={
              cohortDetailsStore.cohortDetailsList?.length > 0 &&
              cohortDetailsStore.cohortDetailsList[0].category !== ''
                ? 'Edit Cohort'
                : 'Add Cohort'
            }
            queryDataAction={() => {
              if (
                checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )
              ) {
                openModal();
              }
            }}
          />

          <TabSelection
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={handleSelectedIndex}
            recommendationFetched={recommendationFetched}
          />
        </Grid>

        <Grid>
          {selectedTabIndex === 0 && (
            <Grid container>
              <CohortFilterBar />
              <Grid
                container
                style={{ width: '1186px', margin: '18px 0px 28px 0px' }}
              >
                {false && (
                  <Grid style={{ marginRight: '24px' }}>
                    <OverviewCard
                      title={pageConstants.OVERVIEW_CARDS.TOTAL_ELIGIBLE}
                      value={valueWithText(
                        totalEligible?.toString(),
                        'Employees',
                      )}
                      rootStyles={{
                        width: '176px',
                      }}
                      showClickHere
                      handleClickHere={pushToEnrollemntMetrics}
                    />
                  </Grid>
                )}
                <Grid style={{ marginRight: '24px' }}>
                  <OverviewCard
                    title={pageConstants.OVERVIEW_CARDS.TOTAL_ENROLLED}
                    value={totalEnrolled?.totalCount}
                    isMultiValued={true}
                    rightLabelValues={[
                      ['Employees', totalEnrolled?.employees],
                      ['Dependents', totalEnrolled?.dependents],
                    ]}
                    rootStyles={{
                      width: 'auto',
                    }}
                    labelsMinWidth="72px"
                    showClickHere
                    handleClickHere={pushToEnrollemntMetrics}
                  />
                </Grid>

                <Grid style={{ marginRight: '24px' }}>
                  <OverviewCard
                    title={pageConstants.OVERVIEW_CARDS.TOTAL_COST}
                    value={totalCost?.totalCost}
                    isMultiValued={true}
                    rightLabelValues={[
                      ['Medical', totalCost?.totalMedical],
                      ['Rx', totalCost?.totalRx],
                    ]}
                    rootStyles={{
                      width: '276px',
                    }}
                    showClickHere
                    handleClickHere={pushToPlanPerformance}
                  />
                </Grid>

                <Grid style={{ marginRight: '24px' }}>
                  <OverviewCard
                    title={pageConstants.OVERVIEW_CARDS.PMPM}
                    topLabelValues={getPmpmForCohorts(pmpm, [], [])}
                    value={getPmpmValueForCohorts(pmpm, [], [])}
                    rootStyles={{
                      width: '176px',
                    }}
                    showClickHere
                    handleClickHere={pushToPlanPerformance}
                  />
                </Grid>

                <Grid>
                  <OverviewCard
                    title={pageConstants.OVERVIEW_CARDS.PEPM}
                    topLabelValues={getPepmForCohorts(pepm, [], [])}
                    value={getPepmValueForCohorts(pepm, [], [])}
                    rootStyles={{
                      width: '176px',
                    }}
                    showClickHere
                    handleClickHere={pushToPlanPerformance}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                style={{ width: '1176px', justifyContent: 'space-between' }}
              >
                <Grid style={{ marginBottom: '28px' }}>
                  <ClaimsImpactChart
                    data={claimsImpactData?.medicalData}
                    highestClaimImpactName={
                      claimsImpactHigestPaidData.medical.name
                    }
                    highestClaimImpactValue={
                      claimsImpactHigestPaidData.medical.value
                    }
                    isMedical={true}
                  />
                </Grid>
                <Grid style={{ marginBottom: '28px' }}>
                  <ClaimsImpactChart
                    data={claimsImpactData?.rxData}
                    highestClaimImpactName={claimsImpactHigestPaidData.rx.name}
                    highestClaimImpactValue={
                      claimsImpactHigestPaidData.rx.value
                    }
                    isMedical={false}
                  />
                </Grid>
              </Grid>

              {/* <Grid item style={{ marginBottom: '28px' }}>
                <CostTrend
                  cardWidth="1176px"
                  chartWidth="1176"
                  medicalClaimsData={costTrendChartData?.medicalClaimsData}
                  medicalTotalPaid={costTrendChartData?.medicalTotalPaid}
                  rxTotalPaid={costTrendChartData?.rxTotalPaid}
                  rxClaims={costTrendChartData?.rxClaims}
                  xAxisValues={costTrendChartData?.xAxisValues}
                />
              </Grid> */}
              <Grid container>
                <Grid style={{ marginRight: '24px' }}>
                  <CardComponent
                    title={pageConstants.TABLES.TABLE1_TITLE}
                    subTitle={pageConstants.TABLES.TABLE1_SUBTITLE}
                    body={
                      <ClaimMetricsPageTable
                        columns={pageConstants.TABLES.TABLE1_COLUMNS}
                        rows={planPaidTableData}
                      />
                    }
                    height="471px"
                    width="576px"
                  />
                </Grid>
                <Grid>
                  <CardComponent
                    title={pageConstants.TABLES.TABLE2_TITLE}
                    subTitle={pageConstants.TABLES.TABLE2_SUBTITLE}
                    body={
                      <ClaimMetricsPageTable
                        columns={pageConstants.TABLES.TABLE2_COLUMNS}
                        rows={memberPaidTableData}
                      />
                    }
                    height="471px"
                    width="576px"
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          {selectedTabIndex === 1 && (
            <div style={{ width: '1500px', height: '493px', padding: '20px' }}>
              <RecommendationsTab
                recommendationLoading={recommendationLoading}
                isInternalPage={true}
              />
            </div>
          )}
        </Grid>
      </Grid>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData || []}
        loading={aiLoading}
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
      />
    </>
  );
});

export default ClaimMetricsPage;
